export default "void main() {\r\n    updateGPUPickerColors();\r\n    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\r\n}\r\n";